import { render, staticRenderFns } from "./EditSettingsModal.vue?vue&type=template&id=efbdc408&"
import script from "./EditSettingsModal.vue?vue&type=script&lang=js&"
export * from "./EditSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports